﻿const navigationSubmenuAttribute = 'data-nav-submenu';
const navigationSubmenuSelector = `[${navigationSubmenuAttribute}]`;
const navigationSubmenuBtns = document.querySelectorAll(navigationSubmenuSelector);

navigationSubmenuBtns.forEach((element, index, parent) => {
    element.addEventListener('click', toggleSubmenu);
});

function toggleSubmenu(event) {
    event.preventDefault();
    let targetSelector = event.currentTarget.getAttribute(navigationSubmenuAttribute);
    let target = document.querySelector(targetSelector);
    target.classList.toggle('open');
}

document.addEventListener('keydown', function (e) {
    if (e.keyCode == 27) {
        let elements = document.querySelectorAll('.main-nav .open');
        elements.forEach((element, index, parent) => {
            element.classList.remove('open');
        });
    }
});

const collapseButtonAttribute = 'data-menu-collapse';
const collapseButtonSelector = `[${collapseButtonAttribute}]`;
const collapseButton = document.querySelector(collapseButtonSelector);
const collapseMenu = document.querySelector('.main-nav');
if (collapseButton) {
    collapseButton.addEventListener('click', function () {
        collapseMenu.classList.toggle('max-h-0');
    });
}